import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { removeJob } from "../../features/DeleteJobs/DeleteJobSlice";

const JobList = ({ job }) => {
  const { id, title, salary, deadline, type } = job;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const dynamicColor = () => {
    if (type === "Full Time") {
      return "#FF8A00";
    }
    if (type === "Internship") {
      return "#FF5757";
    }
    if (type === "Remote") {
      return "#56E5C4";
    }
  }; 

  const handleDelete = (id) =>{
    dispatch(removeJob(id))  
  }

  return (
    <div className="jobs-list">
      {/* <!-- Single Job 1--> */}
      <div className="lws-single-job">
        <div className="flex-1 min-w-0">
          <h2 className="lws-title">{title}</h2>
          <div className="job-footers">
            <div className="lws-type">
              {/* <!-- Fulltime - #FF8A00,  --><!-- Internship - #FF5757,  --><!-- Remote - #56E5C4,  --> */}
              <i
                className={`fa-solid fa-stop !text-[${dynamicColor()}]  text-lg mr-1.5`}
              ></i>
              {type}
            </div>
            <div className="lws-salary">
              <i className="fa-solid fa-bangladeshi-taka-sign text-slate-400 text-lg mr-1.5"></i>
              BDT {salary}
            </div>
            <div className="lws-deadline">
              <i className="fa-regular fa-calendar text-slate-400 text-lg mr-1.5"></i>
              Closing on {deadline}
            </div>
          </div>
        </div>
        <div className="mt-5 flex lg:mt-0 lg:ml-4">
          <span className="hidden sm:block">
            <button
              onClick={() => navigate(`/editJob/${id}`)}
              type="button"
              className="lws-edit btn btn-primary"
            >
              <i className="fa-solid fa-pen text-gray-300 -ml-1 mr-2"></i>
              Edit
            </button>
          </span>

          <span className="sm:ml-3">
            <button onClick={() => handleDelete(id)} type="button" className="lws-delete btn btn-danger ">
              <i className="fa-solid fa-trash text-gray-300 -ml-1 mr-2"></i>
              Delete
            </button>
          </span>
        </div>
      </div>
      {/* <!-- Single Job 1--> */}
    </div>
  );
};

export default JobList;
